<template>
  <!-- <img :width="width" src="~/assets/images/user-shape-grey.png" /> -->
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_13_14482"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect
        :width="width"
        :height="height"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_13_14482)">
      <path
        d="M7.99984 8.00002C7.2665 8.00002 6.63873 7.73891 6.1165 7.21669C5.59428 6.69447 5.33317 6.06669 5.33317 5.33335C5.33317 4.60002 5.59428 3.97224 6.1165 3.45002C6.63873 2.9278 7.2665 2.66669 7.99984 2.66669C8.73317 2.66669 9.36095 2.9278 9.88317 3.45002C10.4054 3.97224 10.6665 4.60002 10.6665 5.33335C10.6665 6.06669 10.4054 6.69447 9.88317 7.21669C9.36095 7.73891 8.73317 8.00002 7.99984 8.00002ZM2.6665 13.3334V11.4667C2.6665 11.0889 2.76373 10.7417 2.95817 10.425C3.15262 10.1084 3.41095 9.86669 3.73317 9.70002C4.42206 9.35558 5.12206 9.09724 5.83317 8.92502C6.54428 8.7528 7.2665 8.66669 7.99984 8.66669C8.73317 8.66669 9.45539 8.7528 10.1665 8.92502C10.8776 9.09724 11.5776 9.35558 12.2665 9.70002C12.5887 9.86669 12.8471 10.1084 13.0415 10.425C13.2359 10.7417 13.3332 11.0889 13.3332 11.4667V13.3334H2.6665Z"
        :fill="color"
      />
    </g>
  </svg>
</template>

<script lang="ts">
export default defineNuxtComponent({
  props: {
    size: {
      type: Number,
      default: 40
    },
    variant: {
      type: String,
      default: 'dark' // light, dark, semi-light, acent
    },
  },
  setup(props) {
    const color = (() => {
      if (props.variant === 'dark') {
        return '#303030'
      }

      if (props.variant === 'semi-light') {
        return '#a5a5a5'
      }

      if (props.variant === 'light') {
        return '#e5e5e5'
      }

      if (props.variant === 'acent') {
        return '#db7f50'
      }

      // Default: light
      return '#e5e5e5'
    })()

    const width = props.size
    const height = props.size

    return {
      color,
      width,
      height,
    }
  }
})
</script>
